// extracted by mini-css-extract-plugin
module.exports = {"logs":"logs_logs__2Dcdz","log_item":"logs_log_item__34lBc","timestamp":"logs_timestamp__296t_","hoverable":"logs_hoverable__21IqA"};